import { Reveal, MaskLinesInView } from "./motion";

const PARAGRAPHS = [
  "Situada em Rande e envolvida por um magnífico parque arborizado, jardins cuidados, lago e amplos espaços verdes, esta propriedade proporciona um ambiente de rara beleza, onde a autenticidade da paisagem se alia ao conforto e à exclusividade.",
  "Com uma forte ligação à história local, a Casa Montebello é reconhecida como uma propriedade de referência na freguesia, estando associada à origem do próprio lugar de Montebelo. Ao longo das gerações, preservou o seu caráter distinto, mantendo a harmonia entre o património natural e a arquitetura que a torna verdadeiramente singular.",
  "Cada detalhe convida à contemplação. As árvores centenárias, os caminhos que percorrem o parque, o espelho de água e a tranquilidade envolvente criam um cenário onde o tempo abranda e cada momento se transforma numa experiência memorável.",
  "Hoje, a Casa Montebello renasce para acolher quem procura mais do que um espaço: procura um lugar com identidade, elegância e alma. Um cenário privilegiado para estadias, celebrações, eventos privados e experiências exclusivas, onde a privacidade, a natureza e o requinte se encontram em perfeita harmonia.",
  "Aqui, cada amanhecer desperta entre o verde do parque e cada pôr do sol convida a desfrutar de um ambiente único, pensado para proporcionar bem-estar, inspiração e momentos inesquecíveis.",
];

export default function Descricao() {
  return (
    <section id="descricao" data-testid="descricao-section" className="relative py-28 lg:py-40 bg-cream">
      <div className="mx-auto max-w-[1100px] px-6 lg:px-12">
        <Reveal>
          <div className="flex items-center gap-4 mb-8 justify-center">
            <span className="h-px w-14 bg-forest/40" />
            <p className="overline">A Propriedade</p>
            <span className="h-px w-14 bg-forest/40" />
          </div>
        </Reveal>

        <h2 className="text-center font-display text-4xl sm:text-5xl lg:text-[4.6rem] leading-[1.02] tracking-tight text-forest font-light max-w-4xl mx-auto">
          <MaskLinesInView
            lines={[
              "Entre a elegância intemporal",
              <span key="i" className="italic">e a serenidade da natureza.</span>,
            ]}
          />
        </h2>

        <Reveal delay={0.1}>
          <p className="mt-10 text-center text-xl lg:text-2xl leading-relaxed text-muted-foreground max-w-3xl mx-auto font-display italic">
            A Casa Montebello ergue-se como um dos refúgios mais exclusivos da
            região de Felgueiras.
          </p>
        </Reveal>

        <div className="mt-16 lg:mt-20 grid md:grid-cols-2 gap-x-14 gap-y-8 max-w-4xl mx-auto">
          {PARAGRAPHS.map((p, i) => (
            <Reveal key={i} delay={(i % 2) * 0.08}>
              <p className="text-muted-foreground text-base lg:text-[1.05rem] leading-relaxed">
                {p}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 lg:mt-24 text-center border-t border-border/60 pt-16">
            <p className="font-display text-3xl lg:text-5xl text-forest leading-tight max-w-3xl mx-auto">
              Onde a história inspira, a natureza envolve e cada momento se torna{" "}
              <span className="italic text-terracotta">extraordinário.</span>
            </p>
            <p className="mt-8 overline">Casa Montebello · Rande, Felgueiras</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
